// extracted by mini-css-extract-plugin
export var image = "ImageGrid-module--image--49b2b";